import { Button, FormGroup, InlineValuePopover, Input } from "@xola/ui-kit";
import { FieldProps } from "formik";
import React, { useState } from "react";

export const AgeField = ({ field: { value }, form }: FieldProps) => {
    const [inputValue, setInputValue] = useState(value);
    const [yearsOpened, setYearsOpened] = useState(false);

    const handleSubmitAge = (e: any) => {
        e.preventDefault();
        form.setFieldValue("age", inputValue);
        setYearsOpened(false);
    };

    const handleChange = (e: any) => {
        setInputValue(e.target.value);
    };

    return (
        <InlineValuePopover
            showArrow
            text={<var data-var="years">{value} year(s)</var>}
            isOpen={yearsOpened}
            classNames={{ text: "font-bold" }}
            onClick={() => setYearsOpened(!yearsOpened)}
            onClickOutside={() => setYearsOpened(!yearsOpened)}
        >
            <FormGroup className="!m-0 flex flex-row space-x-2">
                <Input type="number" value={inputValue ? Math.abs(inputValue) : undefined} onChange={handleChange} />
                <Button onClick={handleSubmitAge}>Apply</Button>
            </FormGroup>
        </InlineValuePopover>
    );
};
